// extracted by mini-css-extract-plugin
module.exports = {"ratingOptions":"RatingOptions_ratingOptions__3APtr","ratingOpts":"RatingOptions_ratingOpts__3zqgW"};